import React, { useContext, useEffect, useState } from 'react';
import intl from 'react-intl-universal';
import AvatarEditor from './AvatarEditor';
import Checkbox from '../Common/Checkbox';
import { debounce } from '../../utils/util';
import Protocol from '../Protocol/UsageProtocol';
import './Dialog.scss';
import Mask from '../Mask';
import { ThemeContext } from '../../store/ThemeProvider';
import ReactSVG from 'react-svg';
import { IPersonStatus } from '../Followee/Person';
import URLUtil from '../../utils/url';
import { alpha } from '../../utils/color';
import {
  clearAllBodyScrollLocks,
  disableBodyScroll,
  enableBodyScroll
} from 'body-scroll-lock';

interface IAlbumDialog {
  submit: (obj?: any) => PromiseLike<any>;
  dialogData?: IPersonStatus;
  hide: () => void;
  editBuddyId?: number;
  useName?: boolean;
  onInvalidFile?: (message: string) => void;
}

const AlbumDialog = function(props: IAlbumDialog) {
  const MAX_IMAGE_SIZE = 10 * 1024 * 1024;
  const ACCEPTED_IMAGE_TYPES = ['image/jpeg', 'image/png'];
  const ACCEPTED_IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png'];

  const getFileExtension = (fileName: string = '') => {
    const split = fileName.split('.');
    return (split.pop() || '').toLowerCase();
  };

  const isAllowedImageFile = (file: File) => {
    const fileType = (file.type || '').toLowerCase();
    const fileExt = getFileExtension(file.name);
    return (
      ACCEPTED_IMAGE_TYPES.includes(fileType) ||
      ACCEPTED_IMAGE_EXTENSIONS.includes(fileExt)
    );
  };

  const [shouldProtocolShow, setShouldProtocolShow] = useState(false);
  const showProtocol = debounce((e: React.MouseEvent<HTMLAnchorElement>) => {
    e.stopPropagation();
    setShouldProtocolShow(true);
  }, 2000);
  const hideProtocol = () => {
    setShouldProtocolShow(false);
  };

  const [name, setName] = useState('');

  const [showTip, setShowTip] = useState(false);
  const [check, setCheck] = useState(true);
  const { dialogData } = props;
  const { faceurl = '', id = '', status = 'unfollow' } = dialogData || {};

  const [imageFile, setImageFile] = useState('' as any);
  const onFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!check) {
      setShowTip(true);
      setTimeout(() => {
        setShowTip(false);
      }, 2000);
      try {
        e.target.value = '';
      } catch (err) {}
      return;
    }

    if (e.target.files && e.target.files.length) {
      const selectedFile = e.target.files[0];

      if (!isAllowedImageFile(selectedFile)) {
        props.onInvalidFile && props.onInvalidFile(intl.get('FaceUploadOnlyJpgPng'));
        return;
      }

      if (selectedFile.size > MAX_IMAGE_SIZE) {
        props.onInvalidFile && props.onInvalidFile(intl.get('FaceUploadMaxSize10MB'));
        return;
      }

      setImageFile(selectedFile);
      // @ts-ignore
      // disableBodyScroll(document.querySelector('.avatar-editor-wrapper'));
    }
    try {
      e.target.value = '';
    } catch (err) {}
  };

  console.log(`dialog faceurl`, dialogData);
  useEffect(() => {
    let timer = 0;
    if (faceurl) {
      // 解析一下 faceurl
      let parse = null;
      let parseUrl = faceurl;
      if (parseUrl.indexOf('http') != 0) {
        parseUrl = `http:${faceurl}`;
      }

      parse = URLUtil(parseUrl);

      try {
        let process = decodeURIComponent(parse.getParam('x-oss-process')).split(
          'crop,'
        );
        let item1 = process[1];
        process = item1.split(',');

        let rect = {} as any;
        (process || []).forEach((it: string) => {
          let arr = it.split('_');
          rect[arr[0]] = Number(arr[1]);
        });

        const WIDTH = Math.min(window.innerWidth, 750);
        const FRAME = Math.round(WIDTH * 0.84);
        let between_x = Math.abs(FRAME - rect.w);
        let between_y = Math.abs(FRAME - rect.h);
        if (Number(rect.w) <= FRAME && Number(rect.h) <= FRAME) {
          rect.x = Math.round(rect.x - between_x / 2);
          rect.y = Math.round(rect.y - between_y / 2);

          rect.w = rect.h = FRAME;
        } else {
          let percent = FRAME / Math.max(rect.w, rect.h);
          if (Number(rect.w) == Number(rect.h) && Number(rect.w) > FRAME) {
          } else {
            if (Number(rect.w) > FRAME) {
              rect.x = Math.round(percent * (rect.x + between_x / 2));
            } else {
              rect.x = Math.round(rect.x - between_x / 2);
            }
            if (Number(rect.h) > FRAME) {
              rect.y = Math.round(percent * (rect.y + between_y / 2));
            } else {
              rect.y = Math.round(rect.y - between_y / 2);
            }
          }

          // let event = new Event('avatar-editor-zoom');
          // event.data = percent;

          // timer = window.setTimeout(()=>{
          //   window.dispatchEvent(event);
          // }, 500);

          rect.w = rect.h = Math.round(FRAME / percent);
        }
        // @ts-ignore
        parseUrl = `${parse.url}?x-oss-process=image/resize,m_lfit,w_1920,limit_0/crop,x_${rect.x},y_${rect.y},w_${rect.w},h_${rect.h},g_nw`;
      } catch (e) {
        // console.log(e);
      }
      console.log(parseUrl);
      setImageFile(parseUrl);
    }

    return () => {
      window.clearTimeout(timer);
    };
  }, [faceurl]);

  const { componentColor, h1Color, mainColor, h2Color } = useContext(
    ThemeContext
  );

  return shouldProtocolShow ? (
    <Protocol show={shouldProtocolShow} close={hideProtocol} />
  ) : (
    <Mask style={{ justifyContent: 'center' }}>
      <>
        <div
          className="face-detection-wrapper"
          style={{ backgroundColor: alpha(componentColor, 1), color: h2Color }}
        >
          <div className="face-title-row" style={{ color: h1Color }}>
            <ReactSVG
              src={require('../../svg/upload-title-bg.svg')}
              className={'title-bg'}
              style={{ fill: alpha(mainColor, 0.5) }}
            />
            <div style={{ position: 'relative' }}>
              {intl.get('Face Recognition')}
            </div>
          </div>
          <div className="face-desc-row" style={{ color: h1Color }}>
            {intl.get('FaceRecognitionDesc')}
          </div>
          <div className="face-frame-row">
            <img src={require('../../assets/face-dialog-border.png')} />
            <input
              className="file-field"
              type="file"
              accept="image/*,.jpg,.jpeg,.png"
              onChange={onFileChange}
              multiple={false}
            />
          </div>
          <div className="close" onClick={props.hide}>
            <img src={require('../../assets/x-36.png')} />
          </div>

          <div
            className="protocol-row"
            onClick={() => setCheck(prevState => !prevState)}
          >
            <Checkbox checked={check} />
            <div>
              {intl.get('Upload and agree')}
              <a onClick={showProtocol} style={{ color: mainColor }}>
                《{intl.get('Jfoto service agreement')}》
              </a>
            </div>
            <div className={'tooltip ' + (showTip ? 'show' : '')}>
              {intl.get('Please read and agree to the agreement firstly')}
              <div className="triangle" />
            </div>
          </div>
        </div>
        {imageFile ? (
          <div className="avatar-editor-wrapper">
            <AvatarEditor
              image={imageFile}
              useName={props.useName}
              onCancel={() => {
                setImageFile((null as unknown) as File);
                // @ts-ignore
                // enableBodyScroll(document.querySelector('.avatar-editor-wrapper'));

                if (faceurl) {
                  props.hide();
                }
              }}
              disabled={!!faceurl}
              onSubmit={(params: any) => {
                if (
                  props.editBuddyId === 0 &&
                  faceurl &&
                  params &&
                  !params.image
                ) {
                  params.image = faceurl;
                  params.personid = id;
                }

                return props.submit(params);
              }}
            />
          </div>
        ) : null}
      </>
    </Mask>
  );
};

export default AlbumDialog;
